export default {
  API_URL:
    process.env.REACT_APP_DOCKER || process.env.NODE_ENV === 'production'
      ? 'https://wens-api.wensdigital.com/api'
      : 'https://wens-api.wensdigital.com/api'
}

// export default {
//   API_URL:
//     process.env.REACT_APP_DOCKER || process.env.NODE_ENV === 'production'
//       ? 'https://wens-api.wensdigital.com/api'
//       : 'http://localhost:9012/api'
// }
